import { Table } from "../../../features/Table";
import { type K2Issuer, issuers_columns } from "./columns";
import { type FilterK2IssuersSchema, FilterK2Issuers } from "./filter";
import { useTranslation } from "react-i18next";

const client = "k2";
const table_name = "k2_issuers";

export const K2IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<K2Issuer, FilterK2IssuersSchema>
      label={t(`${table_name}.title`, { defaultValue: "Issuers" })}
      client={client}
      table_name={table_name}
      columns={issuers_columns}
      filter={<FilterK2Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
